import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var shadowTypes = {
  sm: 'sm',
  lg: 'lg'
};
export var radiusTypes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
export var paddingTypes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};

var shadowMapValues = function shadowMapValues(theme) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, shadowTypes.sm, theme.sd_size_1), _defineProperty(_ref, shadowTypes.lg, theme.sd_size_2), _ref;
};

var radiusMapValues = function radiusMapValues(theme) {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, radiusTypes.sm, theme.rad_xs), _defineProperty(_ref2, radiusTypes.md, theme.rad_xl), _defineProperty(_ref2, radiusTypes.lg, theme.rad_xxl), _ref2;
};

var paddingMapValues = function paddingMapValues(theme) {
  var _ref3;

  return _ref3 = {}, _defineProperty(_ref3, paddingTypes.sm, "".concat(theme.space_4, "px")), _defineProperty(_ref3, paddingTypes.md, "".concat(theme.space_6, "px")), _defineProperty(_ref3, paddingTypes.lg, "".concat(theme.space_8, "px")), _ref3;
};

export var getShadow = function getShadow(shadow, theme) {
  return shadowMapValues(theme)[shadow];
};
export var getRadius = function getRadius(radius, theme) {
  return radiusMapValues(theme)[radius];
};
export var getPadding = function getPadding(padding, theme) {
  return paddingMapValues(theme)[padding];
};